import type { InstallTestV2V5Id } from "~domain/install-tests/models/v2v5/install-test-v2v5-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { backofficeFindV2v5InstallTestsResponseSchema } from "~infrastructure/api/backoffice/contract/install-tests/responses/backoffice-find-v2v5-install-tests-response.ts";
import { backofficeFindV2v5InstallTestsResultsResponseSchema } from "~infrastructure/api/backoffice/contract/install-tests/responses/backoffice-find-v2v5-install-tests-results-response.ts";
import { backofficeFindVxInstallTestsResponseSchema } from "~infrastructure/api/backoffice/contract/install-tests/responses/backoffice-find-vx-install-tests-response.ts";

const c = initContract();

export const installTestsBackofficeContract = c.router(
  {
    findV2V5InstallTests: {
      method: "GET",
      path: "/api/modulator/:modulatorHwId/installtests",
      pathParams: z.object({
        modulatorHwId: z.number(),
      }),
      responses: {
        200: backofficeFindV2v5InstallTestsResponseSchema,
      },
    },
    findV2V5InstallTestsResults: {
      method: "GET",
      path: "/api/installtest/:installTestV2V5Id/results",
      pathParams: z.object({
        installTestV2V5Id: z.number().transform((s) => s as InstallTestV2V5Id),
      }),
      responses: {
        200: backofficeFindV2v5InstallTestsResultsResponseSchema,
      },
    },
    findVxInstallTests: {
      method: "GET",
      path: "/api/vx/testing/site/:siteId",
      pathParams: z.object({
        siteId: z.number().transform((s) => s as SiteId),
      }),
      responses: {
        200: backofficeFindVxInstallTestsResponseSchema,
      },
    },
  },
  {
    strictStatusCodes: true,
  },
);
